import { render, staticRenderFns } from "./DetailActivityModal.vue?vue&type=template&id=67b27110&scoped=true&"
import script from "./DetailActivityModal.vue?vue&type=script&lang=js&"
export * from "./DetailActivityModal.vue?vue&type=script&lang=js&"
import style0 from "./DetailActivityModal.vue?vue&type=style&index=0&id=67b27110&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b27110",
  null
  
)

export default component.exports